import { h } from 'preact'
import EmptyPage from '../../empty-page/EmptyPage'
import globals from '../../../utils/globals'
import Overview from '../../overview'
import UserCell from '../../overview/cells/UserCell'
import DateCell from '../../overview/cells/DateCell'
import TitleCell from '../..//overview/cells/TitleCell'
import StatusCell from '../../overview/cells/StatusCell'
import ActionByUserCell from '../../overview/cells/ActionByUserCell'
import IconCell from '../../overview/cells/IconCell'
import { ModerationLabel } from '../../overview/filters/types'
import { author, moderationLabel } from '../../overview/filters/filters'

type Props = {
  moderationLabels: ModerationLabel[],
}

const ProductUpdateOverview = ({ moderationLabels } : Props) => {
  function getFilters () {
    return [
      moderationLabel(moderationLabels),
      author()
    ]
  }

  function getColumns () {
    return [
      { header: 'Title', accessor: 'title', cell: TitleCell(), size: 'xl', isFixed: true },
      { header: 'Status', accessor: 'status', cell: StatusCell(), size: 'xs' },
      { header: 'Likes', accessor: 'likes', size: 'xs-right', cell: IconCell('likes', 'like') },
      { header: 'Publish date', accessor: 'publishedAt', cell: DateCell('publishedAt'), sorting: 'publishedAt' },
      { header: 'Author', accessor: 'author', cell: UserCell('author') },
      { header: 'Last edited', accessor: 'lastEdit', cell: ActionByUserCell('lastEdit'), sorting: 'lastEditedAt', size: 'l' }
    ]
  }

  return <Overview
    type='product-update'
    headerTitle='Product Updates'
    withPagination={{
      page: 1,
      pageSize: 25
    }}
    withSorting={{
      lastEditedAt: 'desc'
    }}
    withFilters={getFilters()}
    withSearch
    searchPlaceholder='Search in title and content'
    withColumns
    rowId='id'
    model={getColumns()}
    endpoint='/product-update/overview/topics'
    dataKey='topics'
    EmptyStateComponent={<EmptyPage
      img_src={`${globals('defaultCdn')}/images/empty_page.png`}
      header='No product update found'
      text={'Seems like no one on your team has created any product update. Start now by creating a new product update.'}
      button={{ link: '/content/new/product_update', text: 'New product update' }}
    />}
  />
}

export default ProductUpdateOverview
